import React, {useEffect, useRef, useState} from 'react';
import putWithAuth from "../../context/putWithAuth";
import InteractiveSearch from "../../components/interactiveSearch";

function TeacherActivationModal({setTeacherActivationModal, teacherContext, school}) {
    const [isLoading, setIsLoading] = useState(null);
    const [studentsToDeactivate, setStudentsToDeactivate] = useState([]);
    const [studentsToActivate, setStudentsToActivate] = useState([]);
    const [studentFilterText, setStudentFilterText] = useState(null);


    const onClose = () => {
        setTeacherActivationModal(null)
    }

    const handleClose = (e) => {
        if ( e.target.id === "wrapper" ) onClose();
    }

    const handleFilterStudentClick = (e) => {
        if (teacherContext.find(teacher => teacher._id.$oid === e.target.id).active) {
            let currentStudentsToDeactivate = [...studentsToDeactivate]
            currentStudentsToDeactivate.push(e.target.id)
            setStudentsToDeactivate(currentStudentsToDeactivate)
        } else {
            let currentStudentsToActivate = [...studentsToActivate]
            currentStudentsToActivate.push(e.target.id)
            setStudentsToActivate(currentStudentsToActivate)
        }
    }

    const handleAddTeacherClick = (e) => {
        setStudentsToActivate(studentsToActivate.filter(item => item !== e.target.id))
    }

    const handleRemoveTeacherClick = (e) => {
        setStudentsToDeactivate(studentsToDeactivate.filter(item => item !== e.target.id));
    }

    const handleFilterChange = (e) => {
        setStudentFilterText(e.target.value);
    }

    const modalRef = useRef(null);

    useEffect(() => {
        // Ensure modalRef.current is not null before attempting to add the listener
        const modalElement = modalRef.current;

        // Focus the first focusable element when the modal opens
        const focusableElements = modalElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        focusableElements[1].focus();

        const trapFocus = (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab: Move focus backward
                    if (document.activeElement === firstFocusableElement) {
                        e.preventDefault();
                        lastFocusableElement.focus();
                    }
                } else {
                    // Tab: Move focus forward
                    if (document.activeElement === lastFocusableElement) {
                        e.preventDefault();
                        firstFocusableElement.focus();
                    }
                }
            } else if (e.key === 'Escape') {
                // Close the modal when Escape is pressed
                onClose(e);
            }
        };

        modalElement.addEventListener('keydown', trapFocus);

        return () => {
            if (modalElement) {
                modalElement.removeEventListener('keydown', trapFocus);
            }
        };
    }, [setTeacherActivationModal]);

    const putModifyStudentActivationStatus = async () => {
        if (window.confirm('Please confirm you have selected all accounts that need to be modified.')) {
            let body = {
                usersToActivate: studentsToActivate,
                usersToDeactivate: studentsToDeactivate,
                school: school
            }

            setIsLoading(true);
            putWithAuth('/accountmanagement/putModifyActiveAccounts', school, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: body})
                .then((response) => {
                    if (response.ok) {
                        window.alert('Teacher accounts successfully modified.')
                        setIsLoading(false)
                        setTeacherActivationModal(false)
                    } else {
                        console.log(response.error)
                        setIsLoading(false);
                    }
                })
        } else {
            return null;
        }
    }


    return (
        <>
            <div>
                <div className={"fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center flex-col z-10"} id="wrapper" onClick={handleClose}>
                    <div className={"relative bg-platinum-500 p-2 m-4 rounded h-[90%] w-[90%]"} ref={modalRef}>
                        <button onClick={onClose} className="absolute -top-6 -right-6 m-2 p-2 w-10 rounded-full bg-burnt_sienna text-white">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path fill="#fff" d="M14.12 12l5.3-5.3c.59-.59.59-1.54 0-2.12-.59-.59-1.54-.59-2.12 0L12 9.88 6.7 4.58c-.59-.59-1.54-.59-2.12 0-.59.59-.59 1.54 0 2.12L9.88 12l-5.3 5.3c-.59.59-.59 1.54 0 2.12.59.59 1.54.59 2.12 0L12 14.12l5.3 5.3c.59.59 1.54.59 2.12 0 .59-.59.59-1.54 0-2.12L14.12 12z"/>
                            </svg>
                        </button>

                        <div className={'p-2 bg-columbia_blue-800 flex flex-col h-full overflow-auto w-full'}>
                            <div className={'p-2 bg-dutch_white-200 flex h-full'}>
                                <div className={'bg-platinum-900 rounded-lg p-1 w-1/5 max-h-full'}>
                                    <InteractiveSearch placeholder={'Search Name or Grade'}
                                                       handleChange={handleFilterChange}/>
                                    <div
                                        className={'bg-platinum-900 p-4 flex flex-col overflow-y-auto gap-1 max-h-[90%] w-full rounded text-sm'}>

                                        {(studentFilterText) && <>
                                            {teacherContext.filter(item => (!studentsToActivate.includes(item._id.$oid)) && (!studentsToDeactivate.includes(item._id.$oid))).filter(item => item.firstName.toLowerCase().includes(studentFilterText.toLowerCase()) || item.lastName.toLowerCase().includes(studentFilterText.toLowerCase())).map(student =>
                                                (student.active) ? <button id={student._id.$oid}
                                                                           className={'p-2 bg-columbia_blue rounded h-fit select-none hover:bg-columbia_blue-600 cursor-pointer'}
                                                                           onClick={handleFilterStudentClick}>
                                                        <p id={student._id.$oid}>{student.firstName} {student.lastName}</p>
                                                    </button> :
                                                    <button id={student._id.$oid}
                                                            className={'p-2 bg-burnt_sienna rounded h-fit select-none hover:bg-columbia_blue-600 cursor-pointer'}
                                                            onClick={handleFilterStudentClick}>
                                                        <p id={student._id.$oid}>{student.firstName} {student.lastName}</p>
                                                    </button>

                                            )}
                                        </>
                                        }
                                    </div>
                                </div>
                                <div className={'flex flex-col w-4/5 max-h-full overflow-y-auto'}>

                                    <div className={'grid grid-cols-2 grow'}>
                                        <div>
                                            <p className={'text-columbia_blue-800 font-bold text-2xl select-none'}>Teachers
                                                to
                                                Reactivate:</p>

                                            <div className={'flex flex-wrap gap-2 p-2 mx-auto'}>
                                                {teacherContext.sort((a, b) => a.lastName.localeCompare(b.lastName)).filter(item => studentsToActivate.includes(item._id.$oid)).map(item =>
                                                    <button id={item._id.$oid}
                                                            className={'p-2 grow bg-columbia_blue-400 shadow border-[1px] border-columbia_blue-800 rounded h-fit select-none hover:bg-columbia_blue-500 cursor-pointer text-columbia_blue-900'}
                                                            onClick={handleAddTeacherClick}>
                                                        <p id={item._id.$oid}>{item.firstName} {item.lastName}</p>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <p className={'text-columbia_blue-800 font-bold text-2xl select-none'}>Teachers
                                                to
                                                Deactivate:</p>

                                            <div className={'flex flex-wrap gap-2 p-2'}>
                                                {teacherContext.sort((a, b) => a.lastName.localeCompare(b.lastName)).filter(item => studentsToDeactivate.includes(item._id.$oid)).map(item =>
                                                    <button id={item._id.$oid}
                                                            className={'p-2 grow bg-burnt_sienna-200 rounded shadow border-[1px] border-burnt_sienna-800 h-fit select-none hover:bg-burnt_sienna-300 cursor-pointer text-columbia_blue-900'}
                                                            onClick={handleRemoveTeacherClick}>
                                                        <p id={item._id.$oid}>{item.firstName} {item.lastName}</p>
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <button onClick={putModifyStudentActivationStatus}
                                    className="absolute self-center rounded -bottom-6 align-middle m-2 p-2 bg-burnt_sienna text-white font-bold px-10 text-xl hover:bg-burnt_sienna-600">
                                <p>Modify Teacher Accounts</p>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-10">
                    {/* Loader */}
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-100"></div>
                </div>
            )}
        </>
    );
}

export default TeacherActivationModal;